import { Isbn } from '@/module/Author/Book';
import { PublicationIdentifiers, ReclaimablePublication } from '@/module/Author/Publication/model/PublicationTypes';
import { Journal } from '@/module/Journal';
import { Publisher } from '@/module/Publisher';

import { Author, PublishedAt } from '@feature/utils';

export type ImportStateType = 'NOT_IMPORTED' | 'IMPORTED_BUT_NOT_CLAIMED' | 'IMPORTED';

export const importEntityTypeList = ['ARTICLE', 'PROCEEDING', 'ABSTRACT', 'BOOK', 'CHAPTER'] as const;

export type ImportEntityType = (typeof importEntityTypeList)[number];

export interface ImportItem {
  type: ImportEntityType;
  title: string;
  journalName: string | null;
  publisherName: string | null;
  journal: Journal | null;
  publisher: Publisher | null;

  bookName: string | null;
  volume: string | null;
  volumeNo: string | null;

  startPage: number | null;
  endPage: number | null;
  noOfPages: number | null;

  publishedAt: PublishedAt;

  identifiers: PublicationIdentifiers;
  link: string | null;
  isbn: Isbn;

  authors: Author[];
}

export interface ImportState {
  item: ImportItem;
  state: ImportStateType;
  publication: ReclaimablePublication | null;
}

export interface ImportResult {
  list: ImportState[];
}
